import React, { useEffect, useState } from "react"
import { Handle, useStoreState } from 'react-flow-renderer'

import { FiTrash2 } from 'react-icons/fi'
import { getVideoEmbedUrl, parseVideoUrl } from '@helps/parseVideoUrl'

import styles from './style.module.css'

const VideoDemonstration = ({
    onDragStart = () => { }
}) => {
    return (
        <div className={styles.container_demonstration} onDragStart={onDragStart} draggable>
            <p>Видео</p>
        </div>
    )
}

const dataInit = {
    url: '',
    id: '',
    onChange: () => { },
    onRemove: () => { }
}

const Video = ({
    id = '',
    data = {}
}) => {
    const [_data, setData] = useState({ ...dataInit, ...data })

    const [, , zoom] = useStoreState(state => state.transform)
    const showContent = zoom >= 0.6

    const embedUrl = getVideoEmbedUrl(_data.url)

    useEffect(() => {
        _data.onChange(id, _data)
    }, [_data, id])

    return (
        <div className={styles.container}>
            <Handle type='target' position='left' id='in' className={styles.point_in} />
            <FiTrash2
                className={styles.icon}
                onClick={() => data.onRemove(id)}
            />
            <p>Видео</p>
            {showContent ?
                <>
                    <input
                        value={_data.url}
                        onChange={({ target: { value } }) => {
                            const parsed = parseVideoUrl(value)
                            setData(prev => ({
                                ...prev,
                                url: value,
                                id: parsed ? parsed.id : '',
                            }))
                        }}
                        placeholder='Ссылка на видео'
                    />
                    {embedUrl ?
                        <div className={styles.youtube}>
                            <iframe
                                src={embedUrl}
                                title="Видео"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                        :
                        <div className={`${styles.skeleton} ${styles.skeleton__image}`} />
                    }
                </>
                :
                <>
                    <div className={`${styles.skeleton} ${styles.skeleton__input}`} />
                    <div className={`${styles.skeleton} ${styles.skeleton__image}`} />
                </>
            }
            <Handle type='source' position='right' id='out' className={styles.point_out} />
        </div>
    )
}

export { Video, VideoDemonstration }